/**
 * MechaniX is a US product: dates, times, numbers and money always format as
 * US English, whatever the viewer's browser is set to. Passing `undefined`
 * instead follows the browser — a laptop set to UK or Indian English then shows
 * 24-hour times, "2 Oct" dates and lakh-grouped money ("$1,00,000").
 */
export const APP_LOCALE = 'en-US';

/** "Oct 2, 2026, 3:30 PM" for an epoch-seconds value, in the viewer's zone. */
export const formatTimestamp = (epochSeconds: number) =>
  new Date(epochSeconds * 1000).toLocaleString(APP_LOCALE, { dateStyle: 'medium', timeStyle: 'short' });
